import React from 'react'
import ReactDOM from 'react-dom'
import './i18n'
import './index.css'
import 'lib/strMethods'
import 'lib/arrMethods'
import App from './App'
import { BrowserRouter, Route, Switch } from 'react-router-dom'
import reportWebVitals from './reportWebVitals'
import RootStore from './store/rootStore'
import { SnackbarProvider } from 'notistack'
import { createTheme, ThemeProvider } from '@material-ui/core'
import ruLocale from 'date-fns/locale/ru'
import { MuiPickersUtilsProvider } from '@material-ui/pickers'
import DateFnsUtils from '@date-io/date-fns'
import 'react-image-lightbox/style.css'

const theme = createTheme({
  typography: {
    fontFamily: 'Raleway'
  }
})

ReactDOM.render(
  <SnackbarProvider
    anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
    autoHideDuration={4000}
  >
    <MuiPickersUtilsProvider utils={DateFnsUtils} locale={ruLocale}>
      <ThemeProvider theme={theme}>
        <RootStore>
          <BrowserRouter>
            <Switch>
              <Route path="/" component={App} />
            </Switch>
          </BrowserRouter>
        </RootStore>
      </ThemeProvider>
    </MuiPickersUtilsProvider>
  </SnackbarProvider>,

  document.getElementById('root')
)
//
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
